module.exports = __webpack_public_path__ + "img/remark_09.1c580fda.svg";